




























import { TemplateRef } from "@/components/types/template";

export default {
  name: "CustomTagInput",
  model: {
    prop: "value",
    event: "update"
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    tagList: {
      get() {
        return this.value;
      },
      set(value: string[]) {
        this.$emit("update", value);
      }
    },

    hasDefaultSlot() {
      return Boolean(this.$scopedSlots.default);
    },

    hasSelectedSlot() {
      return Boolean(this.$scopedSlots.selected);
    },

    hasEmptySlot() {
      return Boolean(this.$slots.empty);
    },

    hasHeaderSlot() {
      return Boolean(this.$slots.header);
    },

    hasFooterSlot() {
      return Boolean(this.$slots.footer);
    }
  },

  methods: {
    selectTag(value: string) {
      this.$emit("input", value);
      const tagInput = this.$refs.tagInput as TemplateRef;
      tagInput.$parent.$el.click();
    }
  }
};
